import { findSimilarNames } from '../../text/index.js';
import { fold } from '../utils/text.js';

export interface IRankedNameOptions {
  /** Substring hits first (today's behavior, order preserved), then close
   *  matches appended without duplicates. */
  options: string[];
  /** The names that are close matches — they wear the chip. */
  closeMatches: Set<string>;
  /** The first close match — what the save guard and the nudge name. Null
   *  while the typed name is empty, fold-exact, or has no close match. */
  closeMatch: string | null;
}

/**
 * The combobox option list, fuzz included — so an existing name stays visible
 * even when the typed spelling's substring filter would lose it (typing
 * "RebarD16" must still show "Rebar D16"). A fold-exact query short-circuits:
 * the user has landed on a real name and there is nothing to warn about.
 */
export function rankNameOptions(query: string, suggestions: string[]): IRankedNameOptions {
  const trimmed = query.trim();
  const foldedQuery = fold(trimmed);
  const options = suggestions.filter((s) => fold(s).includes(foldedQuery));
  const closeMatches = new Set<string>();
  if (trimmed === '' || suggestions.some((s) => fold(s) === foldedQuery)) {
    return { options, closeMatches, closeMatch: null };
  }
  const fuzzy = findSimilarNames(trimmed, suggestions);
  for (const name of fuzzy) {
    if (!options.includes(name)) options.push(name);
    closeMatches.add(name);
  }
  return { options, closeMatches, closeMatch: fuzzy[0] ?? null };
}
